import React from "react"

export default class Project extends React.Component {

	componentWillMount() {

	}

	scrollToTop() {
		const   scrollHeight = window.scrollY,
						scrollStep = Math.PI / ( 1200 / 15 ),
						cosParameter = scrollHeight / 2;
		var     scrollCount = 0,
						scrollMargin;

		requestAnimationFrame(step);        

		function step () {
			setTimeout(function() {
				if ( window.scrollY != 0 ) {
								requestAnimationFrame(step);
						scrollCount = scrollCount + 1;  
						scrollMargin = cosParameter - cosParameter * Math.cos( scrollCount * scrollStep );
						window.scrollTo( 0, ( scrollHeight - scrollMargin ) );
				}
			}, 15 );
		}
	}  

	render() {
		return(
			<footer>
				<ul>
					<li className="footer__logo" id="scrollToTop" onClick={ this.scrollToTop.bind(this)}></li>
					<li><a target="_blank" href="https://medium.com/@thomas_hoadley">Notes</a></li>
					<li><a target="_blank" href="https://uk.linkedin.com/in/thomashoadley">LinkedIn</a></li>
					<li><a target="_blank" href="https://twitter.com/Thomas_Hoadley">Twitter</a></li>
				</ul>
			</footer>
		)    
	}
}


/** WEBPACK FOOTER **
 ** ./js/components/footer.js
 **/